// For box-shadow
export const shadowScheme = {
  depth1: '0px 1px 0px 0px rgba(0, 0, 0, 0.05)',
  depth2: '0px 2px 1px 0px rgba(0, 0, 0, 0.05), 0px 0px 1px 0px rgba(0, 0, 0, 0.25)',
  depth3: '0px 0px 2px 0px rgba(0, 0, 0, 0.20), 0px 2px 10px 0px rgba(0, 0, 0, 0.10)',
  depth4: '0px 0px 3px 0px rgba(0, 0, 0, 0.10), 0px 4px 20px 0px rgba(0, 0, 0, 0.15)',
} as const;
